import { Alert, AlertTitle, Button } from "@mui/material";
import classNames from "classnames";
import styles from "./sessionExpired.module.scss";

export default function SessionExpired(
  props: Readonly<{ isSessionExpired: boolean }>,
) {
  return (
    <>
      {props.isSessionExpired /* Cookies are shared between all tabs of the same domain */ ? (
        <>
          <br />
          <Alert
            severity="error"
            variant="outlined"
            className={classNames(styles.alert)}
          >
            <AlertTitle>
              For security, you must only open this website in a single
              tab/window and not multiple.
            </AlertTitle>
            <b>Your information will NOT be saved</b>.<br />
            In order to solve this issue for this current window,
            <br />
            please
            <Button onClick={() => window.location.reload()}>
              reload the page
            </Button>{" "}
            now.
          </Alert>
          <br />
        </>
      ) : null}
    </>
  );
}
